import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Button } from '@components/Button';
import { TextPairing } from '@components/TextPairing';
import { themeSpace, themeMediaQuery, themeVariant } from '@utils/styledTheme.util';
import { HEIGHT, CTA_HEIGHT, CTA_HEIGHT_MOBILE, CONTAINER_PADDING } from './BabyRegistry.constants';

export const SectionWrapper = styled(Flex)`
  position: relative;
  height: ${HEIGHT};
  ${themeMediaQuery('below_sm')} {
    height: auto;
    min-height: auto;
    flex-direction: column;
    padding: ${themeSpace(8)} ${themeSpace(7)};
  }
  ${themeMediaQuery('mobile')} {
    padding: ${themeSpace(6)} ${themeSpace(6)};
    margin-bottom: ${themeSpace(5)} !important;
  }
  ${themeMediaQuery('tablet')} {
    img {
      object-position: bottom;
    }
  }
`;

export const TextContainer = styled(Flex)`
  top: 0;
  left: 0;
  z-index: 4;
  width: 100%;
  height: 100%;
  position: absolute;
  align-items: flex-start;
  ${themeMediaQuery('below_sm')} {
    position: relative;
    height: auto;
  }
  ${themeMediaQuery('sm')} {
    align-items: center;
  }
`;

export const LottieContainer = styled(Flex)`
  padding: 0px ${themeSpace(6)};
  width: 100%;
  min-height: 100%;
  ${themeMediaQuery('tablet')} {
    padding-top: ${themeSpace(10)};
  }
  ${themeMediaQuery('below_sm')} {
    padding: 0;
    padding-top: 0;
    min-height: auto;
  }
  ${themeMediaQuery('sm')} {
    width: fit-content;
    margin-left: auto;
    padding-top: 0;
    transform: scale(0.9);
  }
  ${themeMediaQuery('md')} {
    transform: scale(1);
    padding: 0px ${CONTAINER_PADDING};
  }
`;

export const EyebrowWrapper = styled(Flex)`
  align-items: flex-end;
  ${themeMediaQuery('below_sm')} {
    align-items: center;
    justify-content: center;
    > div {
      flex-direction: row;
      align-items: center;
    }
  }
  ${themeMediaQuery('mobile')} {
    margin-bottom: ${themeSpace(3)};
    /* Remove gap and reduce eyebrow size */
    > div {
      gap: 0;
    }
    span {
      ${themeVariant('sectionEyeBrow16')};
    }
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 432px;
    margin-bottom: ${themeSpace(5)};
    ${themeVariant('calloutHed28')}
  }
  .text-pairing-body {
    max-width: 432px;
    ${themeVariant('featureCopy16')}
  }
  ${themeMediaQuery('mobile')} {
    .text-pairing-title {
      font-size: 24px;
      line-height: 32px;
      margin-bottom: ${themeSpace(3)};
    }
  }
  ${themeMediaQuery('lg')} {
    .text-pairing-title {
      max-width: 502px;
      ${themeVariant('calloutHed32')}
    }
    .text-pairing-body {
      max-width: 502px;
      ${themeVariant('featureCopy17')}
    }
  }
`;

export const ExploreButton = styled(Button)`
  height: ${CTA_HEIGHT_MOBILE};
  border-width: 2px;
  ${themeMediaQuery('sm')} {
    height: ${CTA_HEIGHT};
  }
`;

export const VideoContainer = styled.div`
  width: 100%;
  height: 100%;
  ${themeMediaQuery('below_sm')} {
    position: relative;
    margin-top: ${themeSpace(6)}; /* 24px / 1.5rem */
    width: 100%;
    aspect-ratio: 16 / 10;
    border-radius: 16px;
    overflow: hidden;

    img {
      object-position: center bottom !important;
    }
  }
  ${themeMediaQuery('mobile')} {
    margin-top: ${themeSpace(4)}; /* 12px for tighter spacing */
    border: 1px solid rgba(0, 0, 0, 0.06);
  }
`;
